import { __rest } from "tslib";
import React, { createContext, useContext } from 'react';
import cls from 'classnames';
import { usePrefixCls } from '../__builtins__';
import { List } from 'antd-mobile';
export const FormLayoutDeepContext = createContext(null);
export const FormLayoutShallowContext = createContext(null);
export const useFormDeepLayout = () => useContext(FormLayoutDeepContext);
export const useFormShallowLayout = () => useContext(FormLayoutShallowContext);
export const useFormLayout = () => (Object.assign(Object.assign({}, useFormDeepLayout()), useFormShallowLayout()));
export const FormLayout = (_a) => {
    var { shallow, children, prefixCls, className, style } = _a, props = __rest(_a, ["shallow", "children", "prefixCls", "className", "style"]);
    const deepLayout = useFormDeepLayout();
    const formPrefixCls = usePrefixCls('form', { prefixCls });
    const layoutPrefixCls = usePrefixCls('formily-layout', { prefixCls });
    const layoutClassName = cls(layoutPrefixCls, {
        [`${formPrefixCls}-${props.layout}`]: true,
        [`${formPrefixCls}-${props.size}`]: props.size,
    }, className);
    const renderChildren = () => {
        const newDeepLayout = Object.assign(Object.assign({}, deepLayout), { __layout__: true });
        if (!shallow) {
            Object.assign(newDeepLayout, props);
        }
        else {
            if (props.size) {
                newDeepLayout.size = props.size;
            }
        }
        return (React.createElement(FormLayoutDeepContext.Provider, { value: newDeepLayout },
            React.createElement(FormLayoutShallowContext.Provider, { value: shallow ? props : undefined }, children)));
    };
    return (React.createElement(List, { className: layoutClassName, style: style, mode: props.mode }, renderChildren()));
};
FormLayout.defaultProps = {
    shallow: true,
};
FormLayout.useFormDeepLayout = useFormDeepLayout;
FormLayout.useFormShallowLayout = useFormShallowLayout;
FormLayout.useFormLayout = useFormLayout;
export default FormLayout;
//# sourceMappingURL=index.js.map